import { useState, useEffect } from "react";
import { SITE_URL } from "../constants/apiUrls";
import { useGetOptimisedCompanyDetailsQuery } from "../store/Company/companyApiSlice";
const LOCAL_URL = `${SITE_URL}/api/company/details/`;

function useCompanyData(id, trevexToken, worldBoxToken) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const {data:trevexData, isError} = useGetOptimisedCompanyDetailsQuery({companyId: id, token:trevexToken});

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        if (id.includes("TRX") ) {
          if (trevexData) {
            setData(trevexData);
          }
        } else {
          const worldBoxData = await fetchWorldBoxCompanyData(
            id,
            worldBoxToken
          );
          if (isMounted) {
            setData(worldBoxData);
          }
        }
      } catch (error) {
        setError(error.message);
      }

      setIsLoading(false);
    };

    if (!id) {
      setError("ID is required");
      return;
    }

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [id, trevexToken, worldBoxToken, trevexData]);

  return { data, isLoading, error };
}

async function fetchTrevexCompanyData(id, trevexToken) {
  const trevexUrl = `${LOCAL_URL}${id}`;

  const response = await fetch(trevexUrl, {
    headers: {
      Authorization: `Token ${trevexToken}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch Trevex business data");
  }

  const data = await response.json();

  const modifiedData = {
    isTrevex: true,
    data: data,
  };

  return modifiedData;
}

async function fetchWorldBoxCompanyData(id, worldBoxToken) {
  const worldBoxUrl = `/api/company/worldbox-search/${id}`;

  const response = await fetch(worldBoxUrl, {
    headers: {},
  });

  if (!response.ok) {
    throw new Error("Failed to fetch WorldBox business data");
  }

  const data = await response.json();
  const modifiedData = {
    isTrevex: false,
    data: {
      country_code: data.company.countrycode,
      registered_company_name: data.company.name,
      wb_win: data.company.win,
    },
  };

  return modifiedData;
}

export default useCompanyData;
